import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "balanca-page"
  }, [_c('b-card', {
    staticClass: "mb-5 border-0 shadow-sm onboarding-card"
  }, [_c('div', {
    staticClass: "d-flex flex-wrap justify-content-between align-items-start"
  }, [_c('div', {
    staticClass: "onboarding-copy"
  }, [_c('h3', {
    staticClass: "font-weight-bolder mb-2"
  }, [_vm._v("Balança deste computador")]), _c('p', {
    staticClass: "text-muted mb-3"
  }, [_vm._v(" Instale o aplicativo uma vez. O ambiente deste PDV, o adaptador e a porta da balança serão detectados automaticamente. ")]), _c('div', {
    staticClass: "d-flex flex-wrap"
  }, [_c('b-button', {
    staticClass: "mr-2 mb-2",
    attrs: {
      "variant": "primary",
      "disabled": !_vm.downloads.windows
    },
    on: {
      "click": function click($event) {
        return _vm.baixarAgente(_vm.downloads.windows);
      }
    }
  }, [_c('i', {
    staticClass: "flaticon-download mr-1"
  }), _vm._v(" Baixar Balança para Windows (.exe) ")]), _c('b-button', {
    staticClass: "mr-2 mb-2",
    attrs: {
      "variant": "outline-primary",
      "disabled": !_vm.downloads.macos
    },
    on: {
      "click": function click($event) {
        return _vm.baixarAgente(_vm.downloads.macos);
      }
    }
  }, [_c('i', {
    staticClass: "flaticon-download mr-1"
  }), _vm._v(" Baixar Balança para macOS (.dmg) ")]), _c('b-button', {
    staticClass: "mb-2",
    attrs: {
      "variant": "success",
      "disabled": _vm.pareando
    },
    on: {
      "click": _vm.conectarEsteComputador
    }
  }, [_c('i', {
    staticClass: "flaticon2-link mr-1"
  }), _vm._v(" " + _vm._s(_vm.pareando ? "Conectando..." : "Conectar este computador") + " ")])], 1), !_vm.downloads.windows || !_vm.downloads.macos ? _c('small', {
    staticClass: "text-warning d-block mt-1"
  }, [_vm._v(" Os instaladores ainda não foram publicados neste ambiente. ")]) : _c('small', {
    staticClass: "text-muted d-block mt-1"
  }, [_vm._v(" Versão " + _vm._s(_vm.downloads.version) + " · Depois de instalar, clique em “Conectar este computador”. ")])]), _c('div', {
    staticClass: "status-local",
    class: _vm.statusLocal.classe
  }, [_c('strong', [_vm._v(_vm._s(_vm.statusLocal.titulo))]), _c('span', [_vm._v(_vm._s(_vm.statusLocal.mensagem))]), _c('b-button', {
    staticClass: "p-0 mt-1",
    attrs: {
      "size": "sm",
      "variant": "link"
    },
    on: {
      "click": _vm.verificarAgenteLocal
    }
  }, [_vm._v("Verificar novamente")])], 1)])]), _c('FilterFields', {
    attrs: {
      "fields": [{
        type: 'text',
        label: 'Nome',
        field: 'nome'
      }, {
        type: 'select',
        label: 'Status',
        field: 'status',
        options: ['Todos', 'online', 'offline']
      }]
    }
  }), _c('TableApp', {
    ref: "balanca",
    attrs: {
      "titulo": "Balanças",
      "acaoBtn": null,
      "api-url": "/balanca/dispositivos/lista",
      "fields": _vm.fields,
      "classFilterColumn": "nome",
      "perPage": 10
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field === 'nome' ? _c('span', [_c('span', {
          staticClass: "text-dark-75 font-weight-bold d-block"
        }, [_vm._v(_vm._s(props.rowData.nome))]), _c('span', {
          staticClass: "text-muted font-size-sm"
        }, [_vm._v(_vm._s(_vm.nomeModelo(props.rowData.modelo)))])]) : _vm._e(), props.field === 'porta_serial' ? _c('span', [_c('span', {
          staticClass: "text-dark-75 font-weight-bold d-block"
        }, [_vm._v(_vm._s(props.rowData.porta_serial || "Aguardando o aplicativo"))]), _c('span', {
          staticClass: "text-muted font-size-sm"
        }, [_vm._v(_vm._s(props.rowData.sistema_operacional || "—"))])]) : _vm._e(), props.field === 'status' ? _c('span', [_c('span', {
          staticClass: "badge",
          class: props.rowData.online ? 'badge-success' : 'badge-secondary'
        }, [_vm._v(" " + _vm._s(props.rowData.online ? "Online" : "Offline") + " ")])]) : _vm._e(), props.field === 'actions' ? _c('span', [_c('div', {
          staticClass: "d-flex"
        }, [_c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: 'Conectar neste computador',
            expression: "'Conectar neste computador'"
          }],
          staticClass: "btn btn-sm btn-icon btn-light-success mr-2",
          on: {
            "click": function click($event) {
              return _vm.parearDispositivo(props.rowData);
            }
          }
        }, [_c('i', {
          staticClass: "flaticon2-link"
        })]), _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: 'Editar',
            expression: "'Editar'"
          }],
          staticClass: "btn btn-sm btn-icon btn-light-primary mr-2",
          on: {
            "click": function click($event) {
              return _vm.abrirModalEditar(props.rowData);
            }
          }
        }, [_c('i', {
          staticClass: "flaticon2-pen"
        })]), _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: 'Excluir',
            expression: "'Excluir'"
          }],
          staticClass: "btn btn-sm btn-icon btn-light-danger",
          on: {
            "click": function click($event) {
              return _vm.excluir(props.rowData);
            }
          }
        }, [_c('i', {
          staticClass: "flaticon2-trash"
        })])])]) : _vm._e()];
      }
    }])
  }), _c('b-modal', {
    ref: "modalDispositivo",
    attrs: {
      "title": "Configuração da balança",
      "centered": "",
      "no-close-on-backdrop": "",
      "ok-title": _vm.salvando ? 'Salvando...' : 'Salvar',
      "ok-disabled": _vm.salvando
    },
    on: {
      "ok": _vm.salvar
    }
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.salvar.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nome do caixa"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.form.nome,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "nome", $$v);
      },
      expression: "form.nome"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Modelo da balança"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.opcoesModelos
    },
    on: {
      "change": _vm.onModeloChange
    },
    model: {
      value: _vm.form.modelo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "modelo", $$v);
      },
      expression: "form.modelo"
    }
  })], 1), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Velocidade"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [2400, 4800, 9600, 19200]
    },
    model: {
      value: _vm.form.baud_rate,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "baud_rate", $$v);
      },
      expression: "form.baud_rate"
    }
  })], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Casas decimais"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "max": "5"
    },
    model: {
      value: _vm.form.casas_decimais,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "casas_decimais", _vm._n($$v));
      },
      expression: "form.casas_decimais"
    }
  })], 1)], 1)], 1), _c('p', {
    staticClass: "text-muted font-size-sm mb-0"
  }, [_vm._v(" A porta USB é detectada e mantida pelo aplicativo instalado neste computador. ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };